/* eslint-disable no-undef */
import { FileIcon, defaultStyles } from "react-file-icon";
import { IoCloudDownloadOutline } from "react-icons/io5";
import TokenManager from "../../providers/auth/token-manager";
import { getCollaborationAppFileLink } from "../../utils/parser";
import { getFileNameAndExtension, truncateText } from "../../utils/string";

const ToolsOutputFile = ({ fileName }) => {
    const tokenManager = TokenManager.getInstance();

    const downloadFile = async () => {
        const link = getCollaborationAppFileLink(fileName, await tokenManager.getToken());
        // window.open(link, "_blank");
        // download link button
        const a = document.createElement("a");
        a.href = link;
        a.download = link.split("/").pop() as string;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <div className="rounded-[8px] bg-[#404040] border-zinc-500 py-[8px] px-[16px] grid grid-cols-[auto_40px] mb-[16px]">
            <div className="flex gap-[8px] items-center">
                <div className="icon w-[30px]">
                    <FileIcon
                        extension={getFileNameAndExtension(fileName).extension}
                        type="document"
                        color="#c1c1c1"
                        labelColor="#3caf50"
                        {...defaultStyles[getFileNameAndExtension(fileName).extension]}
                    />
                </div>
                <div>
                    <p className="text-[15px] font-semibold">
                        {truncateText(getFileNameAndExtension(fileName).name, 27)}
                        {getFileNameAndExtension(fileName).extension}
                    </p>
                </div>
            </div>
            <div className="actions flex items-center justify-end pr-[5px]">
                <button className="" onClick={downloadFile}>
                    <IoCloudDownloadOutline className="text-gray-100" size="20px" />
                </button>
            </div>
        </div>
    );
};

export default ToolsOutputFile;
